export const TOOLBAR_CONFIG = {
  FEATURE_INFO: 'featureInfo',
  ADDRESS_INFO: 'addressInfo',
  FEATURE_SELECTION: 'featureSelection',
  FEATURE_DESELECTION: 'featureDeselection',
  RETURN_TO_CALLING_APPLICATION: 'returnToCallingApp',
  GEOMETRY_EDIT: 'geometryEdit',
  GEOMETRY_DELETE: 'geometryDelete',
  GEOMETRY_SELECT: 'geometrySelect',
  CLIENT_FEATURE_SELECTION: 'clientFeatureSelection',
  ENABLED_MEASURING_TOOLS: 'measuring',
  ENABLED_GAZETTEER: 'gazetteer',
  ENABLED_LOCATION_FINDER: 'locationFinder',
  ENABLED_ZOOM: 'zoom',
  ENABLED_ZOOM_TO_EXTENT: 'zoomToExtent',
  ENABLED_NAVIGATION_HISTORY: 'navigationHistory',
  NAVIGATION_HISTORY_INSTANCE: 'navigationHistoryInstance',
  ENABLED_WPS: 'wps',
  ENABLED_SKETCH: 'sketch',
  ENABLED_ADD_WFS_LAYER: 'addWfsLayer',
  ENABLED_ADD_WMS_LAYER: 'addWmsLayer',
  ENABLED_ADD_SHAPEFILE: 'addShapefile',
  ENABLED_IMPORT_DATA: 'importData',
  ENABLED_ADD_KML_LAYERS: 'addKmlLayers',
  ENABLED_ADD_SELF_SERVICE_LAYER: 'addSelfServiceLayer',
  ENABLED_ADD_TIMELINE_LAYER: 'addTimelineLayer',
  ENABLED_TIMELINE_VISUALIZATION: 'timelineVisualization',
  ENABLED_TIMELINE_VISUALIZATION_3D: 'timelineVisualization3d',
  ENABLED_GRID_SQUARE_LAYER: 'gridSquareLayer',
  ENABLED_AREA_SEARCH: 'areaSearch',
  ENABLED_ROUTING: 'routing',
  ENABLED_ROUTING_ISOCHRONES: 'routingIsochrones',
  IS_GEOCODER_AVAILABLE: 'geocoder',
  AUTOACTIVATE_ACTION_NAME: 'autoactivate', /* a supported map toolbar action name class */
  GAZETTEER_CONFIGURATION: 'gazetteerConfiguration',
  GEOLOCATION_AVAILABLE: 'geolocation',
  MAP_SETTINGS: 'mapSettings'
} as const;

export const ACTIONS = {
  MAP: {
    CLASSIC_PRINT_MAP: 'printMap',
    CLASSIC_ADD_SHAPEFILE: 'addShapeFile',
    RETURN_TO_CALLING_APPLICATION: TOOLBAR_CONFIG.RETURN_TO_CALLING_APPLICATION,
    SHOW_LEGEND: 'showLegend',
    FEATURE_INFO_GROUP: `${TOOLBAR_CONFIG.FEATURE_INFO}--group`,
    FEATURE_INFO: TOOLBAR_CONFIG.FEATURE_INFO,
    ADDRESS_INFO: TOOLBAR_CONFIG.ADDRESS_INFO,
    FEATURE_SELECTION_GROUP: `${TOOLBAR_CONFIG.FEATURE_SELECTION}--group`,
    CLIENT_FEATURE_SELECTION: TOOLBAR_CONFIG.CLIENT_FEATURE_SELECTION,
    ENABLED_MEASURING_TOOLS: `${TOOLBAR_CONFIG.ENABLED_MEASURING_TOOLS}--group`,
    ENABLED_GAZETTEER: TOOLBAR_CONFIG.ENABLED_GAZETTEER,
    ENABLED_LOCATION_FINDER: TOOLBAR_CONFIG.ENABLED_LOCATION_FINDER,
    ENABLED_ROUTING: TOOLBAR_CONFIG.ENABLED_ROUTING,
    ENABLED_ROUTING_ISOCHRONES: TOOLBAR_CONFIG.ENABLED_ROUTING_ISOCHRONES,
    GEOLOCATION_AVAILABLE: TOOLBAR_CONFIG.GEOLOCATION_AVAILABLE,
    ZOOM_OUT: 'zoomOut',
    ZOOM_IN: 'zoomIn',
    DRAG_ZOOM: 'dragZoom',
    ENABLED_ZOOM_TO_EXTENT: TOOLBAR_CONFIG.ENABLED_ZOOM_TO_EXTENT,
    UNDO: 'undo',
    REDO: 'redo',
    WPS: TOOLBAR_CONFIG.ENABLED_WPS,
    ADD_SKETCH: TOOLBAR_CONFIG.ENABLED_SKETCH,
    ADD_LAYER_GROUP: 'addLayer--group',
    ENABLED_TIMELINE_VISUALIZATION: TOOLBAR_CONFIG.ENABLED_TIMELINE_VISUALIZATION,
    ENABLED_TIMELINE_VISUALIZATION_3D: TOOLBAR_CONFIG.ENABLED_TIMELINE_VISUALIZATION_3D,
    ENABLED_AREA_SEARCH: TOOLBAR_CONFIG.ENABLED_AREA_SEARCH,
    CLIENT_GEOMETRY_SELECT: TOOLBAR_CONFIG.GEOMETRY_SELECT,
    CLIENT_GEOMETRY_EDIT: TOOLBAR_CONFIG.GEOMETRY_EDIT,
    CLIENT_GEOMETRY_DELETE: TOOLBAR_CONFIG.GEOMETRY_DELETE,
    CLIENT_UNDO: 'clientUndo',
    CLIENT_REDO: 'clientRedo',
    MAP_SETTINGS: TOOLBAR_CONFIG.MAP_SETTINGS,
    SKETCH_SELECT: 'sketchSelect',
    SKETCH_DELETE: 'sketchDelete',
    SKETCH_BRING_TO_FRONT: 'sketchBringToFront',
    SKETCH_SEND_TO_BACK: 'sketchSendToBack',
    SKETCH_GROUP: 'sketchGroup',
    SKETCH_UNDO: 'sketchUndo',
    SKETCH_REDO: 'sketchRedo',
    TIMELINE_3D_FILTER: 'timeline3DFilter',
    TIMELINE_3D_VIEW_FROM_SOUTH: 'timeline3DViewFromSouth',
    TIMELINE_3D_VIEW_FROM_WEST: 'timeline3DViewFromWest',
    TIMELINE_3D_VIEW_FROM_NORTH: 'timeline3DViewFromNorth',
    TIMELINE_3D_VIEW_FROM_EAST: 'timeline3DViewFromEast',
    TIMELINE_3D_VIEW_FROM_TOP: 'timeline3DViewFromTop',
    TIMELINE_3D_ORTOHRAPHIC_CAMERA: 'timeline3DOrtographicCamera',
    TIMELINE_3D_PERSPECTIVE_CAMERA: 'timeline3DPerspectiveCamera',
    TIMELINE_3D_RESET_CAMERA: 'timeline3DResetCamera',
    TIMELINE_3D_TOGGLE_BOX: 'timeline3DToggleBox',
    TIMELINE_3D_TOGGLE_MAP: 'timeline3DToggleMap',
    TIMELINE_3D_TOGGLE_FLOATING_MAP: 'timeline3DToggleFloatingMap',
    TIMELINE_3D_GO_TO_2D: 'timeline3DGoTo2D',
    WORKBOOK_TIMELINE_3D_GO_TO_2D: 'workbookTimeline3DGoTo2D',
    WORKBOOK_ZOOM_TO_EXTENT: 'workbookZoomToExtent',
    WORKBOOK_PRINT_MAP: 'workbookPrintMap',
    WORKBOOK_CREATE_SKETCH: 'workbookCreateSketch'
  }
} as const;
